// The price the assistant will quote for an upsell, as the admin reads it.
//
// ⚠️ « COUVERTURE RELIEF 3D » IS PRICED BY PACK, like on the website (owner,
// 2026-09-29, « 1a »): the worker quotes and bills the pack price for the
// order's albums and sends those figures as `pack_prices` (1 / 2 / 3 albums).
// Its `upsell_price` is not a price anybody pays, so it is never shown as one.
// Every other product: its own Sales-tab price, exactly as before.
//
// Used by the Sales tab and by the order page's « Options de la commande »
// card (components/admin/OrderAddonsCard.tsx — the label it shows when the
// worker's per-order price is unknown). Guard: src/lib/upsellPrice.test.ts
import type { UpsellProductRow } from './api';

type T = (fr: string, vars?: Record<string, string | number>) => string;

/** The pack prices when this row is priced by pack (the Relief), else null. */
export function packPrices(p: Pick<UpsellProductRow, 'pack_prices'>): number[] | null {
  return Array.isArray(p.pack_prices) ? p.pack_prices.map((n) => Number(n) || 0) : null;
}

/** A price to quote and a Shopify product to bill it against — the RIB rule:
 *  without both, the assistant never offers it. */
export function upsellSellable(p: Pick<UpsellProductRow, 'pack_prices' | 'upsell_price' | 'shopify_product_gid'>): boolean {
  if (!p.shopify_product_gid) return false;
  const pack = packPrices(p);
  return pack ? pack.length > 0 && pack.every((n) => n > 0) : Number(p.upsell_price) > 0;
}

/** « 79 / 118 / 177 MAD selon le pack » for the Relief, « 100 MAD par album »
 *  for a product priced per album (express delivery: 300 MAD on a Trio — the
 *  figure the assistant quotes and bills), « 100 MAD » otherwise. */
export function upsellPriceLabel(p: Pick<UpsellProductRow, 'pack_prices' | 'upsell_price' | 'upsell_per_album'>, t: T): string {
  const pack = packPrices(p);
  if (pack) return t('{prix} MAD selon le pack', { prix: pack.join(' / ') });
  if (p.upsell_per_album) return t('{prix} MAD par album', { prix: Number(p.upsell_price) });
  return `${Number(p.upsell_price)} MAD`;
}
